import { TRPCClientError } from "@trpc/client";

const RATE_LIMITED = "rate_limited";
const TOO_MANY_REQUESTS_STATUS = 429;

export const ASSISTANT_UNAVAILABLE = "assistant_unavailable";
export const CONVERSATION_LIMIT_REACHED = "conversation_limit_reached";

const readErrorDetails = (value: unknown): { code: unknown; httpStatus: unknown } | null =>
  typeof value === "object" && value !== null && !(value instanceof Error)
    ? {
        code: "code" in value ? value.code : undefined,
        httpStatus: "httpStatus" in value ? value.httpStatus : undefined,
      }
    : null;

export const toAssistantErrorCode = (error: unknown): string => {
  const details = readErrorDetails(error instanceof TRPCClientError ? (error as { data: unknown }).data : error);
  if (!details) {
    return ASSISTANT_UNAVAILABLE;
  }
  if (details.httpStatus === TOO_MANY_REQUESTS_STATUS) {
    return RATE_LIMITED;
  }
  return typeof details.code === "string" ? details.code : ASSISTANT_UNAVAILABLE;
};
